<script setup>
import BreezeButton from '@/Components/Button.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, useForm } from '@inertiajs/inertia-vue3';

defineProps({
    status: String,
});

const form = useForm({
    email: '',
});

const submit = () => {
    form.post(route('password.email'));
};
</script>

<template>
    <BreezeGuestLayout>
        <Head title="パスワードを忘れた方" />

        <section class="main login">
            <h2 class="login_title c-heading-h2">パスワードを忘れた方</h2>
            <div class="c-input_row">
                ご登録のメールアドレスを入力してパスワードリセットボタンをタップ（クリック）してください。メールでパスワードリセットリンクをお送りします。
            </div>

            <div v-if="status" class="c-input_row">
                {{ status }}
            </div>

            <BreezeValidationErrors class="mb-4" />

            <form @submit.prevent="submit">
                <div class="c-input_row">
                    <BreezeLabel for="email" value="Email" />
                    <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
                </div>

                <div>
                    <BreezeButton class="c-button" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                        パスワードリセット
                    </BreezeButton>
                </div>
            </form>
        </section>
    </BreezeGuestLayout>
</template>
